import { defineStore } from 'pinia';
import { computed, ref, type Ref } from 'vue';
import { API } from '@vp/common';
import { useConnectionStore } from '@/stores/connection';

export const useAccountStore = defineStore('account', () => {
  const connectionStore = useConnectionStore();
  const apiClient = connectionStore.apiClient!;

  const accountConfig: Ref<API.AccountConfig.AccountConfig.AccountConfig | undefined> = ref();

  const loadAccountConfig = async () => {
    accountConfig.value = await API.AccountConfig.Api.fetchAccountConfig(apiClient);
  };

  const features = computed(() => (accountConfig.value?.features?.filter(f => f.enabled) ?? []).map(({ name }) => name));

  return {
    accountConfig,

    loadAccountConfig,

    features,
  };
});
